<template>
  <transition>
    <div class="company_main_t">
      <!-- 团队建设 -->
      <div class="company_team">
        <div class="company_list">
          <div class="list_item1 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text text_small">公司年会</div>
            </div>
            <img src="../assets/pcImg/work/1.jpg" alt />
          </div>
          <div class="list_item2 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text text_small">公司年会</div>
            </div>
            <img src="../assets/pcImg/work/2.jpg" alt />
          </div>
          <div class="list_item3 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text">公司年会</div>
            </div>
            <img src="../assets/pcImg/work/3.jpg" alt />
          </div>
          <div class="list_item4 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text text_small">节日福利</div>
            </div>
            <img src="../assets/pcImg/work/4.jpg" alt />
          </div>
          <div class="list_item5 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text text_small">节日福利</div>
            </div>
            <img src="../assets/pcImg/work/5.jpg" alt />
          </div>
          <div class="list_item6 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text">节日福利</div>
            </div>
            <img src="../assets/pcImg/work/6.jpg" alt />
          </div>
          <div class="list_item7 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text">日常团建</div>
            </div>
            <img src="../assets/pcImg/work/7.jpg" alt />
          </div>
          <div class="list_item8 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text">篮球赛事</div>
            </div>
            <img src="../assets/pcImg/work/8.jpg" alt />
          </div>
          <div class="list_item9 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text">公司年会</div>
            </div>
            <img src="../assets/pcImg/work/9.jpg" alt />
          </div>
          <div class="list_item10 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text text_small">日常团建</div>
            </div>
            <img src="../assets/pcImg/work/10.jpg" alt />
          </div>
          <div class="list_item11 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text text_small">日常团建</div>
            </div>
            <img src="../assets/pcImg/work/11.jpg" alt />
          </div>
          <div class="list_item12 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text text_small">节日福利</div>
            </div>
            <img src="../assets/pcImg/work/12.jpg" alt />
          </div>
          <div class="list_item13 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text">社团活动</div>
            </div>
            <img src="../assets/pcImg/work/13.jpg" alt />
          </div>
          <div class="list_item14 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text text_small">篮球赛事</div>
            </div>
            <img src="../assets/pcImg/work/14.jpg" alt />
          </div>
          <div class="list_item15 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text text_small">公司旅游</div>
            </div>
            <img src="../assets/pcImg/work/15.jpg" alt />
          </div>
          <div class="list_item16 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text">公司旅游</div>
            </div>
            <img src="../assets/pcImg/work/16.jpg" alt />
          </div>
          <div class="list_item17 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text">节日福利</div>
            </div>
            <img src="../assets/pcImg/work/17.jpg" alt />
          </div>
          <div class="list_item18 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text text_small">日常团建</div>
            </div>
            <img src="../assets/pcImg/work/18.jpg" alt />
          </div>
          <div class="list_item19 list_dom animate__animated animate__fadeInUp">
            <div class="mark_item">
              <div class="mark_item_text text_small">社团活动</div>
            </div>
            <img src="../assets/pcImg/work/19.jpg" alt />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'CompanyTeam',
  data() {
    return {}
  },
  methods: {},
  mounted() {},
  beforeDestroy() {},
}
</script>
<style scope lang="scss">
.company_main_t {
  width: 100%;
  height: 10.8rem;
  background: url('../assets/pcImg/company/bg1.jpg') no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.company_team {
  position: absolute;
  width: 14.3rem;
  height: 7.05rem;
  left: 50%;
  margin-left: -7.15rem;
  top: 0.5rem;

  .company_list {
    width: 100%;
    height: 100%;
    position: relative;
    img {
      display: block;
    }
    .list_item1 {
      width: 1.4rem;
      top: 0rem;
      left: 0rem;
    }
    .list_item2 {
      width: 1.4rem;
      top: 1.43rem;
      left: 0rem;
    }
    .list_item3 {
      width: 4.26rem;
      top: 0;
      left: 1.45rem;
    }
    .list_item4 {
      width: 1.4rem;
      top: 0;
      left: 5.76rem;
    }
    .list_item5 {
      width: 1.4rem;
      top: 1.43rem;
      left: 5.76rem;
    }
    .list_item6 {
      width: 2.82rem;
      top: 0;
      left: 7.2rem;
    }
    .list_item7 {
      width: 4.24rem;
      top: 0;
      left: 10.07rem;
    }
    .list_item8 {
      width: 2.81rem;
      top: 2.85rem;
      left: 0;
    }
    .list_item9 {
      width: 5.67rem;
      top: 2.85rem;
      left: 2.87rem;
    }
    .list_item10 {
      width: 1.4rem;
      top: 2.85rem;
      left: 8.615rem;
    }
    .list_item11 {
      width: 1.4rem;
      top: 5.71rem;
      left: 2.87rem;
    }
    .list_item12 {
      width: 1.4rem;
      top: 7.14rem;
      left: 2.87rem;
    }
    .list_item13 {
      width: 2.82rem;
      top: 5.71rem;
      left: 4.3rem;
    }
    .list_item14 {
      width: 1.4rem;
      top: 5.71rem;
      left: 7.16rem;
    }
    .list_item15 {
      width: 1.4rem;
      top: 7.14rem;
      left: 7.16rem;
    }
    .list_item16 {
      width: 2.82em;
      top: 4.28rem;
      left: 8.61rem;
    }
    .list_item17 {
      width: 2.82em;
      top: 4.28rem;
      left: 11.5rem;
    }
    .list_item18 {
      width: 1.4em;
      top: 7.15rem;
      left: 11.5rem;
    }
    .list_item19 {
      width: 1.4em;
      top: 7.15rem;
      left: 12.93rem;
    }
    .mark_item {
      position: absolute;
      left: 0;
      top: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        rgba(48, 153, 243, 0.6),
        rgba(59, 93, 230, 0.8)
      );
      color: white;
      font-size: 0.36rem;
      text-align: center;
      transition: all 0.5s ease;
      display: table;
      cursor: default;
      font-family: '微软雅黑';
      .mark_item_text {
        display: table-cell;
        vertical-align: middle;
      }
      .text_small {
        font-size: 0.26rem;
      }
    }
    .list_dom {
      position: absolute;
      overflow: hidden;
    }
    .list_dom:hover {
      .mark_item {
        top: 0;
      }
    }
  }
}
</style>